import { Routes } from '@angular/router';

import { ErrorComponent } from './error/error.component';
import { ForbiddenComponent } from './forbidden/forbidden.component';
import { NotFoundComponent } from './not-found/not-found.component';

import { SuiteViewComponent } from '~/core/suite-view/suite-view.component';

export const SUITEVIEWPATH = 'suiteview';

export const CORE_ROUTES: Routes = [
  {
    path: '',
    loadChildren: () => import('~/dashboard/dashboard.module').then((mod) => mod.DashboardModule),
    data: {
      key: 'dashboard'
    }
  },
  {
    path: 'gvb',
    component: ForbiddenComponent
  },
  {
    path: 'ROUTES.search',
    loadChildren: () => import('~/search/search.module').then((mod) => mod.SearchModule),
    data: {
      key: 'search'
    }
  },
  {
    path: 'ROUTES.userdata',
    loadChildren: () => import('~/userdata/userdata.module').then((mod) => mod.UserdataModule),
    data: {
      key: 'userdata'
    }
  },
  {
    path: 'ROUTES.writtenquestionspublish',
    loadChildren: () =>
      import('~/written-questions/written-questions.module').then((mod) => mod.WrittenQuestionsModule),
    data: {
      key: 'writtenquestionspublish'
    }
  },
  {
    path: 'ROUTES.calendar',
    loadChildren: () => import('~/calendar/calendar.module').then((mod) => mod.CalendarModule),
    data: {
      discriminantPathKey: 'CALENDARPATH'
    }
  },
  {
    path: 'ROUTES.meeting',
    loadChildren: () => import('~/meeting/meeting.module').then((mod) => mod.MeetingModule),
    data: {
      discriminantPathKey: 'MEETINGPATH'
    }
  },
  {
    path: 'ROUTES.holiday',
    loadChildren: () => import('~/holiday/holiday.module').then((mod) => mod.HolidayModule),
    data: {
      key: 'holiday'
    }
  },
  {
    path: 'ROUTES.archive',
    loadChildren: () => import('~/archive/archive.module').then((mod) => mod.ArchiveModule),
    data: {
      discriminantPathKey: 'ARCHIVEPATH'
    }
  },
  {
    path: 'ROUTES.dossiers/:id',
    loadChildren: () => import('~/dossiers/dossiers.module').then((mod) => mod.DossiersModule),
    data: {
      discriminantPathKey: 'DOSSIERSPATH'
    }
  },
  {
    path: 'ROUTES.decrees/:id',
    loadChildren: () => import('~/decrees/decrees.module').then((mod) => mod.DecreesModule),
    data: {
      discriminantPathKey: 'DECREESPATH'
    }
  },
  {
    path: 'ROUTES.presence.report',
    loadChildren: () => import('~/presence-report/presence-report.module').then((mod) => mod.PresenceReportModule),
    data: {
      discriminantPathKey: 'PRESENCEREPORTPATH'
    }
  },
  {
    path: 'ROUTES.annotations',
    loadChildren: () => import('~/annotations/annotations.module').then((mod) => mod.AnnotationsModule),
    data: {
      discriminantPathKey: 'ANNOTATIONSPATH'
    }
  },
  {
    path: 'ROUTES.followup',
    loadChildren: () => import('~/followup/followup.module').then((mod) => mod.FollowupModule),
    data: {
      discriminantPathKey: 'FOLLOWUPPATH'
    }
  },
  {
    path: SUITEVIEWPATH,
    children: [
      {
        path: '**',
        component: SuiteViewComponent,
        runGuardsAndResolvers: 'always'
      }
    ],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'ROUTES.archive',
    loadChildren: () => import('~/archive/archive.module').then((mod) => mod.ArchiveModule),
    data: {
      key: 'archive'
    }
  },
  {
    path: 'ROUTES.management',
    loadChildren: () => import('~/management/management.module').then((mod) => mod.ManagementModule),
    data: {
      key: 'management'
    }
  },
  {
    path: 'ROUTES.files',
    loadChildren: () => import('~/files/routes').then((m) => m.FILES_ROUTES)
  },
  {
    path: 'error',
    component: ErrorComponent
  },
  {
    path: '404',
    component: NotFoundComponent
  },
  {
    path: '403',
    component: ForbiddenComponent
  },
  {
    path: '**',
    redirectTo: '404'
  }
];
